//Regex: ([ ]+)[a-zA-Z\<\> ]+ ([a-zA-Z]+);
//Replace: $1$2: other.$2 || null,
export default function (other) {
  other = other || {}
  return {
    orgIds: other.orgIds || null,
    birthday: other.birthday || null,
    startWork: other.startWork || null,
    docNum: other.docNum || null,
    docType: other.docType || null,
    docCountry: other.docCountry || null,
    country: other.country || null,
    city: other.city || null,
    address: other.address || null,
    zip: other.zip || null,
    username: other.username || null,
    code: other.code || null,
    password: other.password || null,
    firstName: other.firstName || null,
    avatar: other.avatar || null,
    color: other.color || null,
    logoLink: other.logoLink || null,
    lastName: other.lastName || null,
    email: other.email || null,
    phone: other.phone || null,
    lang: other.lang || null,
    token: other.token || null,
    roleId: other.roleId || null,
    internPhone: other.internPhone || null,
    cost: other.cost || null,
    smtpList: other.smtpList || null,
    businessUnits: other.businessUnits || null,
    active: other.active || null,
    allBusinessUnits: other.allBusinessUnits || null,
    notRestrictedIP: other.notRestrictedIP || null,
    isMultipleOrgs: other.isMultipleOrgs || null,
    telegramId: other.telegramId || null,
    group: other.group || null,
    managerUserId: other.managerUserId || null,
    additionalPermissions: other.additionalPermissions || [],
  }
}
